import React from "react";
import { Grid } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SettingsCard from "./SettingsCard";

const LISTINGS_PER_PAGE_OPTIONS = ["3", "6", "9", "12"];

const DROPDOWN_STYLE = {
  width: "100%",
  padding: "8px 12px",
  borderRadius: "8px",
  border: "1px solid #D2D6DA",
  fontSize: "14px",
  fontFamily: "inherit",
  backgroundColor: "white",
  cursor: "pointer"
};

const PlaceholderCard = ({ inputData }) => {
  return (
    <SettingsCard
      title="Listings Display Settings"
      subtitle="Configure how many listings are displayed per page"
      gridProps={{
        xs: 12,
        sx: {
          "@media (min-width: 1100px)": {
            flexBasis: "calc(50% - 12px)",
            maxWidth: "calc(50% - 12px)",
            width: "calc(50% - 12px)",
            marginRight: "24px"
          }
        }
      }}
    >
      <Grid container spacing={2.5}>
        <Grid item xs={12}>
          <SoftBox display="flex" flexDirection="column">
            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
              <SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
                textTransform="capitalize"
              >
                Featured Listings Per Page
              </SoftTypography>
            </SoftBox>
            <select
              name="featured_listings_per_page"
              defaultValue={inputData?.featured_listings_per_page || "3"}
              style={DROPDOWN_STYLE}
            >
              {LISTINGS_PER_PAGE_OPTIONS.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </SoftBox>
        </Grid>
        <Grid item xs={12}>
          <SoftBox display="flex" flexDirection="column">
            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
              <SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
                textTransform="capitalize"
              >
                Free Listings Per Page
              </SoftTypography>
            </SoftBox>
            <select
              name="free_listings_per_page"
              defaultValue={inputData?.free_listings_per_page || "3"}
              style={DROPDOWN_STYLE}
            >
              {LISTINGS_PER_PAGE_OPTIONS.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </SoftBox>
        </Grid>
      </Grid>
    </SettingsCard>
  );
};

export default PlaceholderCard;
